import React, { useEffect, useState } from "react";
import { Dialog } from "../Dialog";
import { ErrorBanner, Muted } from "./AppDataStyles";

/**
 * Confirmation for deleting several app data rows at once.
 */
export const BulkDeleteDialog = ({
  show = false,
  count = 0,
  hasLocked = false,
  busy = false,
  error = null,
  onClose = () => {},
  onConfirm = () => {},
}) => {
  const [force, setForce] = useState(false);

  useEffect(() => {
    if (show) setForce(false);
  }, [show]);

  return (
    <Dialog
      title="Delete rows"
      subtitle={`${count} selected`}
      show={show}
      onClose={onClose}
      onOK={() => onConfirm(force)}
      okText={busy ? "Deleting…" : `Delete ${count}`}
      closeText="Cancel"
      style={{ width: "90%", maxWidth: "560px" }}
    >
      <div style={{ fontSize: "14px", color: "var(--main-font-color)" }}>
        Delete <strong>{count}</strong> row{count === 1 ? "" : "s"}?
      </div>

      <Muted>They are permanently removed. This cannot be undone.</Muted>

      {hasLocked ? (
        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "12.5px", color: "#f39c12" }}>
          <input type="checkbox" checked={force} onChange={(event) => setForce(event.target.checked)} />
          Some rows are locked — force the delete
        </label>
      ) : null}

      {error ? <ErrorBanner>{error}</ErrorBanner> : null}
    </Dialog>
  );
};

export default BulkDeleteDialog;
